export const NAMESPACE = 'bookSegments'
